import React, { Component } from 'react';

import './style.css';

export default class Contacts extends Component {
  render() {
    return(
      <div className='contacts'>
        <div className='contacts__background'>
          <div className='contacts__info'>
            <div className='contacts__title'>пишите, звоните!</div>
            <div className='contacts__item contacts__item_email'>
              <a rel='nofollow' className='contacts__item-link' href='mailto: org@happydev-lite.ru'>
                org@happydev-lite.ru
              </a>
              <span className='contacts__item-description'>Мы готовы ответить на любые вопросы</span>
            </div>
            <div className='contacts__item contacts__item_phone' itemScope itemType='http://schema.org/Person'>
              <a rel='nofollow' className='contacts__item-link' href='tel:+79095350073'><span itemProp='telephone'>+ 7 (909) 535 00 73</span></a>
              <span className='contacts__item-description'>
                <span itemProp='givenName'>Анна</span>
                <span itemProp='familyName'> Тарасенко</span>,
                <span itemProp='jobTitle'> главный организатор</span>
              </span>
            </div>
            <div className='contacts__item contacts__item_phone' itemScope itemType='http://schema.org/Person'>
              <a rel='nofollow' className='contacts__item-link' href='tel:+79136402868'><span itemProp='telephone'>+ 7 (913) 640 28 68</span></a>
              <span className='contacts__item-description'>
                <span itemProp='givenName'>Алёна</span>
                <span itemProp='familyName'> Борзунова</span>,
                <span itemProp='jobTitle'> организатор</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout-page/blocks/contacts/Contacts.js